<template>
  <div class="lh-homes imgs" style="background-image:url(img/a1.png?a=1)">
    <div class="lh-logo1"><img src="img/logo-a.png" /><span>安全生产：安全文化</span></div>
    <div class="lh-production-next" data-path="/" @click="gotoNext($event)"><img src="img/btn.png"></div>
    <Footer :footerData="footerData"></Footer>
  </div>
</template>

<script>
import Footer from '@/components/Footer'
export default{
	data(){
		return {
			footerData:{audioData:{total:'00:00',current:'00:00',percentage:0,icon:'icon-bofang',text:''},page:1,type:'culture'},
		}
	},
	created(e){
		var that=this;
	},
	mounted(e){
      var that=this;
    },
	components:{
		Footer
	},
	methods:{
		setCreate(e){
			var that=this,tag = $(e.currentTarget),idx=$(e.currentTarget).data('idx');
			that.$store.commit("setCreate",{idx:idx,$router:that.$router,name:'home'});
		},
		gotoNext(e){
			var that=this,tag = $(e.currentTarget),path=$(e.currentTarget).data('path');
			that.$router.replace({ path: path});
		}
	}
}
</script>
